export default __webpack_public_path__ + "static/media/tablet.73c1898b.jpg";